import { useState } from 'react'
import { isApiError } from '../../api/client'
import { API_COPY } from '../../api/copy'
import type { KbSource } from '@rp/contracts'
import type { KbRetryError } from './KbSourceList'
import { useRetryKbSource } from './queries'

const messageOf = (error: unknown): string => (isApiError(error) ? error.message : API_COPY.offline)

type RetriedSource = Pick<KbSource, 'id' | 'status'>

export const useKbRetry = () => {
  const retry = useRetryKbSource()
  const [retryingId, setRetryingId] = useState<string | null>(null)
  const [retryError, setRetryError] = useState<KbRetryError | null>(null)

  const onRetry = (source: RetriedSource) => {
    setRetryingId(source.id)
    setRetryError(null)
    retry.mutate(source.id, {
      onSuccess: () => setRetryError(null),
      onError: (error) => setRetryError({ id: source.id, status: source.status, message: messageOf(error) }),
      onSettled: () => setRetryingId(null),
    })
  }

  return { onRetry, retryingId, retryError }
}
